import Button from "@components/button";
import Row from "@components/row";
import Typography from "@components/typography";
import theme from "@utils/theme";
import { LucideIcon } from "lucide-react";
import React from "react";

interface HeaderProps {
  title: string;
  icon?: any; // Lucide icons
  hasButton?: boolean;
  btnTitle?: string;
  btnIcon?: any; // Button icon (optional)
  onClick?: () => void;
  secondaryBtnTitle?: string;
  onSecondaryClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  title,
  icon: Icon,
  hasButton = false,
  btnTitle,
  btnIcon,
  onClick,
  secondaryBtnTitle,
  onSecondaryClick,
}) => {
  return (
    <Row styleRow="justify-content:space-between">
      <Row styleRow="align-items:center;gap:8px">
        {Icon && <Icon color={theme.orange.orange700} />}
        <Typography
          size={22}
          weight={500}
          styleText={`color:${theme.orange.orange700}`}
        >
          {title}
        </Typography>
      </Row>

      <Row styleRow="gap: 10px;">
        {secondaryBtnTitle && (
          <Button
            title={secondaryBtnTitle}
            variant="reset"
            styleButton="font-size:12px;padding:0 10px"
            onClick={onSecondaryClick}
          />
        )}
        {hasButton && (
          <Button
            title={btnTitle ?? ""}
            icon={btnIcon}
            styleButton="font-size:12px;padding:0 10px"
            onClick={onClick}
          />
        )}
      </Row>
    </Row>
  );
};

export default Header;
